import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import QRCode from "react-qr-code";
import config from "../../config";
import { useLoader } from "../../hooks/LoaderContext";

const FeQrCodePage = ({ contest_id: propContestId }) => {
  const { id: routeId } = useParams();
  const [qrsetting, setQrSetting] = useState({});
  const contest_id = propContestId || routeId; // support both prop + route param
  const { showLoader, hideLoader } = useLoader();

  const fetchQrCodeDetails = useCallback(async () => {
    showLoader();
    try {
      if (!contest_id) return; // wait until it's defined
      const payload = { contest_id };
      const res = await axios.post(
        `${config.API_URL}/get-qrcode-settings`,
        payload
      );

      if (res.status === 200 && res.data?.qr_settings) {
        const settings = JSON.parse(res.data.qr_settings);
        setQrSetting(settings);
      } else {
        console.warn("QR settings missing or invalid response:", res.data);
      }
    } catch (error) {
      console.error("Error fetching QR code settings:", error);
    } finally {
      hideLoader();
    }
  }, [contest_id]);

  useEffect(() => {
    fetchQrCodeDetails();
  }, [fetchQrCodeDetails]); // run when contest_id becomes available

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black p-4 sm:p-6 md:p-8">
      {qrsetting?.bgLogo && (
        <div className="flex justify-center mb-6 sm:mb-8">
          <img
            src={qrsetting?.bgLogo}
            alt="Logo"
            className="fill-current text-gray-500 w-[100px] h-[50px] md:w-[200px] md:h-[50px] rounded"
          />
        </div>
      )}

      <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 md:p-10 max-w-md w-full">
        <div className="text-center mb-4 sm:mb-6">
          {qrsetting?.qr_text1 && (
            <>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                {qrsetting?.qr_text1}
              </h2>
              <p className="text-sm sm:text-base text-gray-600">
                {qrsetting?.qr_text2}
              </p>
            </>
          )}
        </div>

        <div className="flex justify-center mb-4 sm:mb-6">
          <div className="relative">
            <div className="absolute -top-2 -left-2 w-6 h-6 border-t-4 border-l-4 border-black rounded-tl-lg"></div>
            <div className="absolute -top-2 -right-2 w-6 h-6 border-t-4 border-r-4 border-black rounded-tr-lg"></div>
            <div className="absolute -bottom-2 -left-2 w-6 h-6 border-b-4 border-l-4 border-black rounded-bl-lg"></div>
            <div className="absolute -bottom-2 -right-2 w-6 h-6 border-b-4 border-r-4 border-black rounded-br-lg"></div>

            <div className="border-4 border-black rounded-xl p-4 sm:p-5 md:p-6 bg-white shadow-lg">
              <QRCode
                size={200}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={qrsetting?.contest_url || ""}
                viewBox="0 0 256 256"
                level="H"
              />
            </div>
          </div>
        </div>

        {qrsetting?.qr_text3 && (
          <div className="text-center mb-4 sm:mb-5">
            <p className="text-xs sm:text-sm text-gray-500 mt-1">
              {qrsetting?.qr_text3}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeQrCodePage;
